import { PropertyStatus, ListingType, ListingCategory } from '@domain-group/fe-allhomes-library';
export default searchQuery => {
  if (!searchQuery || !searchQuery.filters) {
    return null;
  }
  var listingTypeObj = ListingType[searchQuery.filters.listingType];
  var status = listingTypeObj.category === ListingCategory.RENT ? PropertyStatus.RENTED.name : PropertyStatus.SOLD.name;
  return searchQuery.cloneWith({
    propertyStatus: searchQuery.isSold() || searchQuery.isRented() ? undefined : [status]
  });
};